import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncSolarIconBold = createAsyncIcon(() => import('./SolarIconBold'));

export default AsyncSolarIconBold;

AsyncSolarIconBold.displayName = 'AsyncSolarIconBold';
